// src/authConfig.js
// MSAL configuration built at boot from runtime config. All exports are live
// bindings assigned by initAuth(); import them freely but only read them inside
// functions/handlers that run after bootstrap.
import { PublicClientApplication } from "@azure/msal-browser";

export let msalConfig = null;
export let b2cPolicies = null;
export let loginRequest = null;
export let msalInstance = null;

let activeConfig = null;

export function getLoginRedirectUri() {
  const b2c = activeConfig?.b2c || {};
  const here = `${window.location.origin}/login`;
  if (b2c.protocolMode === "OIDC") return here;
  return b2c.spaReturnUrl || here;
}

export function relayState(app = "") {
  return JSON.stringify({
    host: window.location.origin,
    path: `${window.location.pathname}${window.location.search}`,
    app: app == null ? "" : String(app),
  });
}

export function initAuth(config) {
  activeConfig = config;
  const { b2c } = config;
  const redirectUri = getLoginRedirectUri();

  msalConfig = {
    auth: {
      clientId: b2c.clientId,
      authority: b2c.authorityUrl + b2c.susiFlow,
      knownAuthorities: [b2c.authorityDomain],
      redirectUri,
      postLogoutRedirectUri: redirectUri,
      navigateToLoginRequestUrl: false,
      ...(b2c.protocolMode === "OIDC" ? { protocolMode: "OIDC" } : {}),
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      allowRedirectInIframe: true,
    },
  };

  b2cPolicies = {
    names: {
      signUpSignIn: b2c.susiFlow,
      resetPassword: b2c.passwordResetFlow,
    },
    authorities: {
      signUpSignIn: {
        authority: b2c.authorityUrl + b2c.susiFlow,
      },
      resetPassword: {
        authority: b2c.authorityUrl + b2c.passwordResetFlow,
      },
    },
    authorityDomain: b2c.authorityDomain,
  };

  loginRequest = {
    scopes: ["openid", "profile", "offline_access", b2c.apiScope],
  };

  msalInstance = new PublicClientApplication(msalConfig);
  return msalInstance;
}
